<template>
  <v-select
    :value="value"
    @input="value => emit(value)"
    :label="config.label"
    :items="incomes"
    item-text="name"
    item-value="code"
    :required="config.required"
    :error="haveErrors()"
    :rules="config.errors"
    dark>
  </v-select>
</template>

<script>
  import input from '@/mixins/input'
  import collection from './collection'
  export default {
    mixins: [input],
    computed: {
      incomes () {
        return collection(this, 'inputs.income.income')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/Income.vue